import React from 'react'
import {useIntl} from 'react-intl'
import useCustomerServicePageConfig from '../hooks/use-page-config'
import Seo from '../../../components/seo'

const CustomerServicePageMeta = () => {
    const {formatMessage} = useIntl()
    const {name, pageDescription, pageKeywords, pageTitle} = useCustomerServicePageConfig()

    const pageTitleString = pageTitle || name
    const customerServiceString = formatMessage({
        defaultMessage: 'Customer Service',
        id: 'global.customerservice'
    })
    const titleText = [pageTitleString, customerServiceString].filter(Boolean).join(' | ')
    return <Seo title={titleText} description={pageDescription} keywords={pageKeywords} />
}

export default CustomerServicePageMeta
